//Api
export const API = "API"
export const API_ACCESS_DENIED = "API_ACCESS_DENIED"
export const API_ERROR = "API_ERROR"

//Resources
export const LIST_RESOURCES = "LIST_RESOURCES"
export const SET_RESOURCES = "SET_RESOURCES"

//Resource
export const GET_RESOURCE = "GET_RESOURCE"
export const SET_RESOURCE = "SET_RESOURCE"

//Asset Events
export const LIST_ASSET_EVENTS = "LIST_ASSET_EVENTS"
export const SET_ASSET_EVENTS = "SET_ASSET_EVENTS"